// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PFolderOpenOutlinedSvg from "@fishx/icons-svg/es/asn/PFolderOpenOutlined";
import FishxIcon from '../components/FishxIcon';

var PFolderOpenOutlined = function PFolderOpenOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PFolderOpenOutlinedSvg
  }));
};

PFolderOpenOutlined.displayName = 'PFolderOpenOutlined';
export default React.forwardRef(PFolderOpenOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PFolderOpenOutlined.js
// module id = 3417
// module chunks = 0